

















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Methods } from "@/models/methods";
import Context from "@/mixins/context";

@Component
export default class ForgottenPasswordFields extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public value!: { email?: string; username?: string; token: string };

  @Prop({ required: true })
  public isProcessing!: boolean;

  // Computed

  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  public async resetPassword() {
    // Generate fresh reCaptcha token
    const recaptcha_token = await this.$store.dispatch(
      "utils/recaptcha/generateToken",
      this.isAdmin ? "user_password_reset" : "client_password_reset"
    );

    // Dispatch password reset
    return this.$store.dispatch("api/call", {
      method: Methods.POST,
      path: this.isAdmin
        ? "api/admin/users/password_reset"
        : "api/clients/password_reset",
      requestConfig: {
        handle401Error: false,
        data: {
          ...(this.isAdmin
            ? { email: this.form.email }
            : { username: this.form.username }),

          recaptcha_token
        }
      },
      callConfig: { withAccessToken: false }
    });
  }
}
